<div class="page-header">
    <div class="page-header-text">You’re enrolled in {{paymentFrequency}} recurring payments</div>
</div>
<div class="page-body">
    <div class="body-text">
        We’ll automatically withdraw your premium payment at the frequency you <br>
        selected, using the same electronic fund transfer (ACH) method you provided for <br>
        your initial premium payment today. 
    </div>
    <a href="https://www.nationwide.com/" class="tM-10px">Return to Nationwide.com</a>
</div>